import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AudienceSwitch.css';

const AudienceSwitch = ({ className = '' }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const venues = pathname.startsWith('/venues');

  return (
    <nav className={`tk-audience ${className}`} aria-label={t('audience.label')}>
      <Link to="/" className={!venues ? 'is-active' : ''} aria-current={!venues ? 'page' : undefined}>
        {t('audience.players')}
      </Link>
      <Link to="/venues" className={venues ? 'is-active' : ''} aria-current={venues ? 'page' : undefined}>
        {t('audience.venues')}
      </Link>
    </nav>
  );
};

export default AudienceSwitch;
